import { render, staticRenderFns } from "./MilestoneTaskGantt.vue?vue&type=template&id=1d392eb0"
import script from "./MilestoneTaskGantt.vue?vue&type=script&lang=js"
export * from "./MilestoneTaskGantt.vue?vue&type=script&lang=js"
import style0 from "./MilestoneTaskGantt.vue?vue&type=style&index=0&id=1d392eb0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VChip,VCol,VDataTable,VIcon,VRow})
